import { gql } from '@apollo/client'

import { getQueryService } from '../../../../helpers/GraphqlHelpers'
import { transformWordings } from '../../../../redux/configuration/transformers'

export const getTranslations = getQueryService({
  query: gql`
    query getTranslations($locale: String) {
      getTranslations(locale: $locale) {
        key
        value
      }
    }
  `,
  transformer: (response) => {
    return transformWordings(response.getTranslations)
  },
})
